import {
  ADD_SKILL,
  EDIT_SKILL,
  SET_CATEGORIES,
  SET_CODER_SKILL_LIST,
  SET_PRIORITIES,
  SET_QUALIFICATION,
  ADD_TOKEN,
  DELETE_SKILL, SET_LEADS_PER_PAGE, SET_PAGE_NUMBER,
} from '../actionTypes';
import api from '../../api';

export function login(data) {
  return (dispatch) => api.post('login_user', { email: data.email, password: data.password })
    .then((res) => {
      localStorage.setItem('token', res.success.token);
      localStorage.setItem('user.id', res.success.user.id);
      window.location.href = '/';
      return dispatch({
        type: ADD_TOKEN,
        payload: res.success.token,
      });
    });
}
export function addSkill(data) {
  const renamedSkillItem = {
    priority_id: parseFloat(data.priority_id),
    category_id: parseFloat(data.category_id),
    qualification_id: parseFloat(data.qualification_id),
    rate: parseFloat(data.rate),
    min_rate: parseFloat(data.min_rate),
    description: data.description ? data.description.toString() : 'No additional information'.toString(),
  };
  return (dispatch) => api.post('project_need', renamedSkillItem).then((res) => {
    const dataWithID = { ...data, id: res.data.id };
    return (res.success === true
      ? dispatch({
        type: ADD_SKILL,
        payload: dataWithID,
      })
      : null);
  });
}
export function deleteSkill(data) {
  return (dispatch) => api.delete('project_need', `${data.id}`, data.id)
    .then((res) => (
      res.success === true
        ? dispatch({
          type: DELETE_SKILL,
          payload: data,
        })
        : null));
}
export function editSkill(data) {
  const parsedData = {
    id: data.id,
    qualification_id: parseFloat(data.qualification_id),
    category_id: parseFloat(data.category_id),
    priority_id: parseFloat(data.priority_id),
    min_rate: parseFloat(data.min_rate),
    rate: parseFloat(data.rate),
    description: data.description,
  };
  return (dispatch) => api.put('project_need', `${parsedData.id}`, parsedData)
    .then((res) => ((res.success === true)
      ? dispatch({
        type: EDIT_SKILL,
        payload: { parsedData },
      }) : null));
}

export function getCoderSkills() {
  return (dispatch) => api.get('project_need')
    .then((res) => ((res.success === true)
      ? dispatch({
        type: SET_CODER_SKILL_LIST,
        payload: res.data,
      }) : null));
}

export function getPriorities() {
  return (dispatch) => api.get('get_priorities')
    .then((res) => ((res.success === true)
      ? dispatch({
        type: SET_PRIORITIES,
        payload: res.data,
      }) : null));
}

export function getJobCategories() {
  return (dispatch) => api.get('get_job_categories')
    .then((res) => ((res.success === true)
      ? dispatch({
        type: SET_CATEGORIES,
        payload: res.data,
      }) : null));
}

export function getQualifications() {
  return (dispatch) => api.get('get_qualifications')
    .then((res) => ((res.success === true)
      ? dispatch({
        type: SET_QUALIFICATION,
        payload: res.data,
      }) : null));
}
